import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import MainLayout from '../containers/MainLayout.container';
import BlogsList from '../components/Blogs/BlogsList';
import BlogPaginate from '../components/Blogs/BlogPaginate';
import DataContext from '../hooks/DataContext';
import { getDistincTags } from '../utils/helperFunctions';
import { useLocation } from '@reach/router';
import Divider from '@material-ui/core/Divider';
import RecommendedPosts from '../components/Posts/RecommendedPosts';
/**
 *
 * @param {props : any} props
 * @require {blogs, categories} = props.data
 */

const CommonTemplate = ({ ...props }) => {
  const { pathname } = useLocation();
  const { blogs, tagsData, recommendedPosts, history } = props.data;
  const { currentPage, category, mainField, subField } = props.pageContext;

  const numPages = props.pageContext.numPages || props.data.numPages;
  //#region Solving tags
  let tags = [];
  if (tagsData && tagsData.edges.length) {
    tags = getDistincTags(tagsData).filter((tag) => {
      let res = true;
      if (category) {
        res = tag.trim().toLowerCase() !== category.trim().toLowerCase() && res;
      }
      if (mainField) {
        res =
          tag.trim().toLowerCase() !== mainField.trim().toLowerCase() && res;
      }
      if (subField) {
        res = tag.trim().toLowerCase() !== subField.trim().toLowerCase() && res;
      }
      return res;
    });
  }
  //#endregion

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [currentPage]);

  const handlePageClick = (data) => {
    const { selected } = data;
    let newPath;
    const fitPath =
      pathname[pathname.length - 1] === '/' ? pathname.slice(0, -1) : pathname;
    const currentPageNumber = fitPath[fitPath.length - 1];
    if (selected + 1 === +currentPageNumber) return;

    let splitPathname = fitPath?.split('/');
    if (!isNaN(parseInt(splitPathname[splitPathname.length - 1]))) {
      splitPathname = splitPathname.slice(0, -1);
    }
    newPath = splitPathname.join('/');
    selected === 0
      ? navigate(newPath || '/')
      : navigate(`${newPath}/${selected + 1}`);
  };

  //  avoid duplication between recommended posts and available posts
  const filterRecommendedPosts = recommendedPosts.nodes.filter(
    (recommendedPost) =>
      blogs.nodes.find(
        (node) => node.contentful_id === recommendedPost.contentful_id
      )
        ? false
        : true
  );

  return (
    <DataContext.Provider value={{ tags, history, props }}>
      <MainLayout>
        <BlogsList blogs={blogs.nodes} />
        {numPages > 1 ? (
          <BlogPaginate
            currentPage={currentPage}
            numPages={numPages}
            handlePageClick={(data) => handlePageClick(data)}
          />
        ) : null}
        <Divider />
        <RecommendedPosts posts={filterRecommendedPosts} />
      </MainLayout>
    </DataContext.Provider>
  );
};

export default CommonTemplate;
